import * as z from "zod";

import { idSchema, surrealRecordSchema } from "./surreal-record";

export const pageTypeSchema = z.enum(["content", "roles"]);

export const publicRoleSchema = z.object({
  id: idSchema,
  name: z.string().optional(),
  externalDescription: z.string().optional(),
});

export const pageSchema = surrealRecordSchema.extend({
  slug: z.string(),
  order: z.number(),
  title: z.string().optional(),
  type: pageTypeSchema.default("content"),
});

export const pagesSchema = z.array(pageSchema);

export const pageContentSchema = pageSchema.omit({ order: true }).extend({
  content: z.string().optional(),
  updatedAt: z.coerce.date().optional(),
  roles: z.array(publicRoleSchema).optional(),
});
export const pageContentsSchema = z.array(pageContentSchema);

export const pageUpdateSchema = z.object({
  title: z.string(),
  content: z.string().optional(),
  type: pageTypeSchema.optional(),
});

export type PageType = z.infer<typeof pageTypeSchema>;
export type PublicRole = z.infer<typeof publicRoleSchema>;
export type Page = z.infer<typeof pageSchema>;
export type PageContent = z.infer<typeof pageContentSchema>;
export type PageUpdate = z.infer<typeof pageUpdateSchema>;
